import { useState } from "react";
import { Gift, Copy, Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export const ReferralLinkMaker = () => {
  const [name, setName] = useState("");
  const [copied, setCopied] = useState(false);
  const clean = name.trim();
  const link = clean ? `${window.location.origin}/?ref=${encodeURIComponent(clean)}` : "";

  const copy = async () => {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    toast.success(`Referral link for ${clean} copied`);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="mt-6 rounded-3xl bg-[#050B1F] p-6 text-white sm:p-8" data-testid="referral-link-maker">
      <div className="flex items-center gap-3">
        <span className="grid h-10 w-10 place-items-center rounded-xl bg-lime-400 text-[#050B1F]"><Gift className="h-5 w-5" /></span>
        <div>
          <p className="font-display text-xl font-extrabold">$250 referral link maker</p>
          <p className="text-sm text-blue-100/85">Type the referrer's name to get their personal link. Anyone who opens it sees the bonus popup with that name filled in.</p>
        </div>
      </div>
      <div className="mt-5 grid gap-3 lg:grid-cols-[1fr_2fr_auto]">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Referrer's name, e.g. John Smith" maxLength={120}
          data-testid="referral-maker-name-input"
          className="w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-[15px] text-white placeholder:text-blue-100/60 outline-none focus:border-lime-300 focus:ring-4 focus:ring-lime-300/30" />
        <div className="flex min-w-0 items-center rounded-xl bg-white/5 px-4 py-3 font-mono text-sm text-lime-200" data-testid="referral-maker-link">
          <span className="truncate">{link || "Your link will appear here"}</span>
        </div>
        <div className="flex gap-2">
          <button onClick={copy} disabled={!link} data-testid="referral-maker-copy-btn"
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-lime-400 px-5 py-3 text-sm font-bold text-[#050B1F] transition-colors hover:bg-lime-300 disabled:opacity-40">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} {copied ? "Copied" : "Copy link"}
          </button>
          {link && (
            <a href={link} target="_blank" rel="noopener noreferrer" data-testid="referral-maker-preview-link" aria-label="Preview link"
              className="grid place-items-center rounded-xl border border-white/20 px-3 text-white hover:border-lime-300 hover:text-lime-300">
              <ExternalLink className="h-4 w-4" />
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
